// About Page
export function aboutPage() {
  return `
<div class="min-h-screen bg-gray-50">
    <div class="hero min-h-[40vh] flex items-center bg-cover bg-center bg-fixed" 
         style="background-image: linear-gradient(135deg, rgba(63, 137, 233, 0.85), rgba(121, 211, 238, 0.75)), url('/images/header1.webp')">
        <div class="hero-content">
            <h1 class="hero-title">EPC Homes Spain</h1>
            <p class="hero-subtitle">
                EPCspainhomes.com is an initiative by energy advisors with more than 15 years of combined experience in the energy certificate market.
            </p>
        </div>
    </div>

    <section class="section bg-gray-50">
        <div class="container">
            <div class="max-w-4xl mx-auto prose prose-lg">
                <div class="bg-white p-8 rounded-lg shadow-sm">
                    <h2 class="text-2xl text-blue-900 mb-4">About us</h2>

                    <div class="space-y-6 text-gray-700">
                        <p>
                            EPCspainhomes.com is an initiative by advisors with more than 15 years of combined experience in the energy certificate market. At EPCspainhomes.com, we are ready to help you obtain your energy certificate quickly and easily. Compare all available advisors and find the company that best suits you.
                        </p>

                        <h2 class="text-2xl text-blue-900 mb-4">About EPCspainhomes.com</h2>
                        <p>
                            As a property owner, you need a new energy certificate approximately once every eight years. It is logical that you are not familiar with this market. Still, you want a good product and pleasant service at a fair price. We make this easy by clearly showing all certified advisors near you. We go one step further by gathering all information about energy certificates in one place. This way, you can quickly find the advisor that best fits your needs.
                        </p>
                        <a href="/about/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">
                            Read more about EPCspainhomes.com
                        </a>

                        <h2 class="text-2xl text-blue-900 mb-4">Why EPCspainhomes.com</h2>
                        <p>
                            You need an energy certificate for your home or commercial property. You are looking for speed and flexibility. You want everything to be well organized, hassle-free, with a smile, and at a competitive price. That is exactly why people choose EPCspainhomes.com! We compare all energy advisors and help you find the one that suits you best. We focus on making difficult things easy. That is why our customers rate us with an average of 4.9 out of 5 stars. We are proud of this and it motivates us to provide you with the best possible service.
                        </p>
                        <a href="/about/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">
                            Read more about why EPCspainhomes.com
                        </a>

                        <h2 class="text-2xl text-blue-900 mb-4">All energy advisors</h2>
                        <p>
                            At EPCspainhomes.com you will find energy advisors available throughout Spain. We offer the most comprehensive comparison of certified advisors in the country. In addition, all advisors we list are qualified and properly certified.
                        </p>
                        <a href="/cadastro/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">
                            View all energy advisors
                        </a>

                        <h2 class="text-2xl text-blue-900 mb-4">All partners</h2>
                        <p>
                            At EPCspainhomes.com we collaborate with various entities in the sector. Our goal is to support affiliated companies in their work and help new professionals enter the market. We are happy to connect you with our trusted partners.
                        </p>
                        <a href="/advisors/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">
                            View all partners
                        </a>

                        <h2 class="text-2xl text-blue-900 mb-4">Our team</h2>
                        <p>
                            Meet the EPCspainhomes.com team! We are here to help you obtain your energy certificate quickly and easily. We specialize in connecting property owners with the certified companies that are part of EPCspainhomes.com.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Team section with minimal distance -->
    <section class="section bg-gray-50 mt-0 pt-0">
        <div class="container">
            <div class="max-w-4xl mx-auto prose prose-lg">
                <div class="bg-white p-8 rounded-lg shadow-sm">
                    <div class="grid grid-cols-1 sm:grid-cols-4 gap-4 items-start">
                        <div class="flex flex-col items-center">
                            <img src="/images/team/Marinus-Over-Ons-EPCSpainHomes.webp" alt="Marinus - EPCSpainHomes team" class="w-48 h-auto rounded-md shadow-md" />
                            <p class="mt-4 text-gray-600 text-center text-sm">Marinus — info@epcspainhomes.com</p>
                        </div>
                        <div class="flex flex-col items-center">
                            <img src="/images/team/Vincent-Over-Ons-EPCSpainHomes.webp" alt="Vincent - EPCSpainHomes team" class="w-48 h-auto rounded-md shadow-md" />
                            <p class="mt-4 text-gray-600 text-center text-sm">Vincent — info@epcspainhomes.com</p>
                        </div>
                        <div class="flex flex-col items-center">
                            <img src="/images/team/Filip-Over-Ons-EPCSpainHomes.webp" alt="Filip - EPCSpainHomes team" class="w-48 h-auto rounded-md shadow-md" />
                            <p class="mt-4 text-gray-600 text-center text-sm">Filip — info@epcspainhomes.com</p>
                        </div>
                        <div class="flex flex-col items-center">
                            <img src="/images/team/Mark-Over-Ons-EPCSpainHomes.webp" alt="Mark - EPCSpainHomes team" class="w-48 h-auto rounded-md shadow-md" />
                            <p class="mt-4 text-gray-600 text-center text-sm">Mark — info@epcspainhomes.com</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>



    `;
}
